// Keep these in sync with the CSS variables in the `_css` directory

;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:ENCON_SENTRY_KEY":true});}catch(e){}}();const cssVariables = {
    breakpoints: {
      l: 1440,
      m: 1024,
      s: 768,
    },
    colors: {
      base0: 'rgb(255, 255, 255)',
      base100: 'rgb(235, 235, 235)',
      base500: 'rgb(128, 128, 128)',
      base850: 'rgb(34, 34, 34)',
      base1000: 'rgb(0, 0, 0)',
      error500: 'rgb(255, 111, 118)',
    },
  }
  
  export default cssVariables
  